import { render, staticRenderFns } from "./ShipmentSummaryButton.vue?vue&type=template&id=33b2fc47&"
import script from "./ShipmentSummaryButton.vue?vue&type=script&lang=js&"
export * from "./ShipmentSummaryButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports